import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BudgetService } from 'app/views/appviews/quote/budget.service';
import { IDtoNote } from 'app/shared/models/quote/note.model';
import { IDtoBudgetNote } from 'app/shared/models/quote/budget-note.model';
import { EnumBudgetStatus } from 'app/shared/enums/budget-status.enum';
import { SecurityService } from 'app/shared/services/security.service';

@Component({
    selector: 'app-modal-notes',
    templateUrl: './modal-notes.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalNotesComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formBudgetNote: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private budgetId?: number;
    private budgetNote: IDtoBudgetNote;
    private profile: string;
    private status?: number;
    /**Catalogos */
    private catalogNotes = new Array() as IDtoNote[];
    /**Listas */
    private budgetNotes = new Array() as IDtoBudgetNote[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableNotes: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private budgetService: BudgetService
        , private configGeneral: AppConfig
        , private securityService: SecurityService) {
        this.initializeFormUserRole();
        this.configToast = this.configGeneral.getConfigToast();
        this.profile = this.securityService.getProfileStorage('BudgetCreation');
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.getBudgetNotes(this.budgetId);
        this.getCatalogNotes();
    }
    private initializeFormUserRole() {
        this.formBudgetNote = this.formBuilder.group({
            noteId: [null, [Validators.required]]
        });
    }
    private submit(): void {
        if (this.budgetId == undefined) {
            this.configGeneral.newToast('Validación', 'Guarde primeramente el presupuesto para poder agregar sus notas', 'warning');
            return;
        }
        if (this.formBudgetNote.valid) {
            let dto = this.formBudgetNote.value as IDtoBudgetNote;
            dto.budgetId = this.budgetId;
            let exist = this.budgetNotes.filter(bf => bf.noteId == dto.noteId);
            if (exist.length > 0) {
                this.configGeneral.newToast('Validación', 'La nota seleccionada ya existe en este presupuesto', 'warning');
                return;
            }
            this.save(dto);
        } else {
            this.configGeneral.newToast('Validación', 'Seleccione la información requerida para poder continuar', 'warning');
        }
    }
    private save(dto: IDtoBudgetNote): void {
        this.budgetService.addBudgetNote(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        const item = x.data as IDtoBudgetNote;
                        let note = this.catalogNotes.filter(n => n.id == item.noteId)[0];
                        item.description = note.description;
                        item.isDefault = note.isDefault;
                        this.budgetNotes.push(item);
                        this.budgetNotes = [...this.budgetNotes];
                        this.resetForm();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private getBudgetNotes(budgetId: number): void {
        if (budgetId == undefined) {
            return;
        }
        this.budgetService.getBudgetNotes(budgetId)
            .subscribe(
                (x) => {
                    this.budgetNotes = x.data as IDtoBudgetNote[];
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private resetForm(): void {
        this.formBudgetNote.reset();
    }
    private getCatalogNotes(): void {
        this.budgetService.getNotes()
            .subscribe(
                (x) => {
                    //let tempCatalogNotes = x.data as IDtoNote[];
                    this.catalogNotes = x.data as IDtoNote[];//tempCatalogNotes.filter(d => d.isDefault == false);
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private deleteBudgetNote(row: IDtoBudgetNote): void {
        this.budgetService.deleteBudgetNote(row.id)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        const index = this.budgetNotes.indexOf(row, 0);
                        if (index > -1) {
                            this.budgetNotes.splice(index, 1);
                        }
                        this.budgetNotes = [...this.budgetNotes];
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }

    private validateButtonTrash(row: IDtoBudgetNote) : boolean {
        let access = true;
        if (row.isDefault || this.profile == 'Cliente' || this.status != 0) {
            access = false;
        }
        return  access;
    }
}
